import React, { useContext } from "react";
import { Icon, Table, Tooltip } from "antd";
import { ColumnProps } from "antd/lib/table/interface";
import styles from "./index.module.scss";
import { InvigilationItemInfo } from "../../../../../service/exam";
import { InvigilationCtx } from "../../context";
import { isTrue } from "../../../../../service/service";
import moment from "moment";
import { useToggle } from "react-use";
import { ButtonBan, ButtonMarkError, ButtonUndoBan } from "../ButtonsUtil";
import { ButtonUploadPage } from "../ButtonsUtil/ButtonUploadPage";
import ButtonDetail from "../ButtonsUtil/ButtonDetail";
import style from "../../../supervise/components/SuperviseTable/index.module.scss";
import StuTableColumn from "../../../../../components/CourseComponents/StuTableColumn";

interface StuTableProps<T extends InvigilationItemInfo> {
    columns?: ColumnProps<T>[];
    extraColumns?: ColumnProps<T>[];
    loading: boolean;
    onErrChange: () => void;
    dataSource: T[];
    buttonShow?: boolean[]; // [禁考，补充附件，标记异常，查看详情]
}

export default function StuTable<T extends InvigilationItemInfo>({
    columns,
    extraColumns,
    onErrChange,
    dataSource,
    buttonShow = [true, true, true, true],
    loading
}: StuTableProps<T>) {
    const { onSelect, currentIndex } = useContext(InvigilationCtx);

    const defaultColumns: ColumnProps<T>[] = [
        {
            title: "打开试卷时间",
            dataIndex: "firstStartTime",
            align: "center",
            width: 100,
            render: time => time && moment(time).format("MM-DD HH:mm")
        }
        // {
        //     title: "提交试卷时间",
        //     dataIndex: "submitTime",
        //     align: "center",
        //     width: 100,
        //     render: time => time && moment(time).format("MM-DD HH:mm")
        // },
        // {
        //     title: "提交状态",
        //     dataIndex: "examFlag",
        //     align: "center",
        //     width: 70,
        //     render: examFlag => (isTrue(examFlag) ? "已提交" : "未提交")
        // },
        // {
        //     title: "附件数量",
        //     dataIndex: "uploadFileNum",
        //     align: "center",
        //     width: 70
        // }
    ];

    const [uploadLoading, onChangeUploadLoading] = useToggle(false);

    const innerColumns: ColumnProps<T>[] = [
        {
            title: "考生信息",
            render: (val, item) => {
                return (
                    <div className={style.stuInfo}>
                        <StuTableColumn
                            name={item.studentName}
                            stuNo={item.studentNo}
                        />
                        {isTrue(item.ban) && (
                            <Tooltip title="该考生存在缺考、弃考或作弊行为、被老师强制“禁考”。">
                                <Icon type="user-add" />
                            </Tooltip>
                        )}
                    </div>
                );
            }
        },
        ...(columns || defaultColumns),
        ...(extraColumns || []),
        {
            title: "操作",
            align: "right",
            width: 300,
            render: (text, item) => (
                <div className={styles.roots}>
                    {!isTrue(item.ban) && (
                        <ButtonBan
                            examId={item.examId.toString()}
                            stuNo={item.studentNo}
                            onOk={onErrChange}
                        />
                    )}

                    {isTrue(item.ban) && (
                        <ButtonUndoBan
                            examId={item.examId.toString()}
                            stuNo={item.studentNo}
                            onOk={onErrChange}
                        />
                    )}

                    {buttonShow[1] && (
                        <ButtonUploadPage
                            stuNo={item.studentNo}
                            examId={item.examId.toString()}
                            onChangeUploadLoading={onChangeUploadLoading}
                        />
                    )}

                    {buttonShow[2] && (
                        <ButtonMarkError
                            examId={item.examId.toString()}
                            stuNo={item.studentNo}
                            onChange={onErrChange}
                        />
                    )}

                    {buttonShow[3] && (
                        <ButtonDetail
                            examId={item.examId.toString()}
                            stuNo={item.studentNo}
                            ban="1"
                            onChange={onErrChange}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <Table
            className={styles.root}
            rowKey={(item, index) => `${index}`}
            columns={innerColumns}
            dataSource={dataSource}
            pagination={false}
            loading={loading || uploadLoading}
            scroll={{ y: 600 }}
            onRow={(record, index) => ({
                onClick: () => onSelect(index)
            })}
            rowSelection={{
                type: "radio",
                selectedRowKeys: [`${currentIndex}`]
            }}
        />
    );
}
